import {
    SHOPIFY_API_HOST,
    NO_WEB_APP,
    NO_SHOPIFY,
    SHOW_OPEN_APP_BANNER,
    SHOW_NAVIGATOR,
    SHOW_HOME_SIGNUP,
    SHOW_BREADCRUMB,
    ACTION_BUTTON_TO_COUPON_PAGE,
    SHOW_SHARE_BUTTON,
    SHOW_FOOTER,
} from 'utils/Config'
import { inMiniProgram } from './WeChatUtil'
import { detectIsPadOrMobileByScreenWidth } from './ScreenUtils'

export const NO_WEBAPP_WHITE_PAGE_LIST = [
    "/campaign/:id",
    "/campaign/detail",
    "/campaign/:id/register_success",
    "/user/completed_success",
    "/unsubscribe_email",
    "/",
]
export const isInsideShopify = () => {
    const inShopify = window.self !== window.top && document.referrer?.includes(SHOPIFY_API_HOST)
    return inShopify
}

export const isNotSimplifiedNoWebapp = () => {
    const inShopify = isInsideShopify()
    if (inShopify) {
        return true
    }
    return !NO_WEB_APP
}

export const showBreadCrumb = () => {
    if (!SHOW_BREADCRUMB) {
        return false
    }
    const isInMiniProgram = inMiniProgram();
    if (isInMiniProgram) {
        return false
    }
    return isNotSimplifiedNoWebapp()
}

export const showMenuButtonInNavigatorBar = () => {
    if (!SHOW_NAVIGATOR) {
        return false
    }
    if (inMiniProgram() || detectIsPadOrMobileByScreenWidth()) {
        return false
    }
    return isNotSimplifiedNoWebapp()
}

export const showBackButtonInNavigatorBar = () => {
    return isNotSimplifiedNoWebapp()
}

export const showStampsTaskActionButton = () => {
    return isNotSimplifiedNoWebapp()
}

export const hideDownloadAppSection = () => {
    return isNotSimplifiedNoWebapp()
}

export const onlyShowWhiteListPage = () => {
    return !isNotSimplifiedNoWebapp()
}